import { createRouter, createWebHistory } from 'vue-router';
import Index from '@/_components/Index.vue';
import Series from '@/_components/Series.vue';

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/gold',
    name: 'gold',
    component: Series
  },
  {
    path: '/tortoiseshell',
    name: 'tortoiseshell',
    component: Series
  },
  {
    path: '/buffalohorn',
    name: 'buffalohorn',
    component: Series
  },
  {
    path: '/en',
    name: 'en_index',
    component: Index
  },
  {
    path: '/en/gold',
    name: 'en_gold',
    component: Series
  },
  {
    path: '/en/tortoiseshell',
    name: 'en_tortoiseshell',
    component: Series
  },
  {
    path: '/en/buffalohorn',
    name: 'en_buffalohorn',
    component: Series
  }
];

const router = createRouter({
  history: createWebHistory('/collections/luxury/2023/'),
  routes
});

export default router;
